import { AxiosRequestConfig } from "axios";
import client from "libs/HttpClient";

/**
 * Represents the structure of a request for listing EmailTemplate.
 */
interface ListEmailTemplateRequest {
  queryKey: [number, string];
}

/**
 * Service class for handling EmailTemplate.
 */
class EmailTemplateService {
  static listEmailTemplate(request: ListEmailTemplateRequest) {
    const page_no = request.queryKey[0];
    const searchText = request.queryKey[1];

    return client.get(
      `admin/email-template/list?page=${page_no}&search_text=${searchText}`,
      request as AxiosRequestConfig
    );
  }

  /**
   * Adds a new EmailTemplate based on the provided request.
   *
   * @param request - The request parameters for adding a EmailTemplate.
   * @returns A Promise that resolves to the Axios response for the add EmailTemplate request.
   */
  static addEmailTemplate(request: any) {
    return client.put("admin/email-template/add", request);
  }

  /**
   * Updates the details of a EmailTemplate based on the provided request.
   *
   * @param request - The request parameters for updating a EmailTemplate.
   * @returns A Promise that resolves to the Axios response for the update EmailTemplate request.
   */
  static updateEmailTemplate(request: any) {
    return client.put("admin/email-template/edit/", request);
  }

  /**
   * Retrieves the details of a EmailTemplate based on the provided parameters.
   *
   * @param params - The parameters for retrieving the EmailTemplate details.
   * @returns A Promise that resolves to the Axios response containing the EmailTemplate details.
   */
  static viewEmailTemplate(params: any) {
    return client.get("admin/email-template/get", { params });
  }
}

export { EmailTemplateService };
